import React, { memo, useCallback, useEffect, useMemo, useState } from "react";

import { LottieAnimation } from "@swiggy-private/core-ui";
import { getCloudinaryUrl, isEmpty } from "@swiggy-private/js-utils";
import { Lottie } from "@swiggy-private/cart-types";
import { lottieProps } from "@cart-client/components/common-header/components/constants";
import { LottieType } from "@cart-client/components/common-header/components/helper";
import { getToingRtbHeaderLottieFrame } from "@cart-client/hooks/useToingRtbHeaderLottie/helpers";

export interface ToingRtbHeaderLottieProps {
    lottieArray: Lottie[];
    showFinalState: boolean;
    onPlayComplete: VoidFunction;
}

const ToingRtbHeaderLottie = ({ lottieArray, showFinalState, onPlayComplete }: ToingRtbHeaderLottieProps) => {
    const [isError, setIsError] = useState(false);

    const lottieUrl = useMemo(() => {
        const lottieId = lottieArray.find((lottie) => lottie.type === LottieType.MAIN)?.lottie_id;
        return getCloudinaryUrl(lottieId) || "";
    }, [lottieArray]);

    useEffect(() => {
        setIsError(false);
    }, [lottieUrl]);

    const handleError = useCallback(() => {
        setIsError(true);
        onPlayComplete();
    }, [onPlayComplete]);

    const handlePlayComplete = useCallback(() => {
        if (!showFinalState) {
            onPlayComplete();
        }
    }, [onPlayComplete, showFinalState]);

    if (isError || isEmpty(lottieUrl)) {
        return null;
    }

    return (
        <LottieAnimation
            {...lottieProps}
            fileName={lottieUrl}
            visible
            playLottie
            autoplay
            isOnFileChangeEnabled={true}
            preserveAspect="xMinYMid slice"
            frame={getToingRtbHeaderLottieFrame(showFinalState)}
            onPlayComplete={handlePlayComplete}
            onError={handleError}
        />
    );
};

export default memo(ToingRtbHeaderLottie);
